export const ROUTES = {
  HOME: "/",
  DESIGNS: "/designs",
};
